import { SortOptions } from '@/shared/types/common';

export const certificatesCourseSortOptions: SortOptions[] = [
  {
    id: '1',
    title: 'By date',
    options: [
      { label: 'from recent', value: 'issuedAt:desc' },
      { label: 'from oldest', value: 'issuedAt:asc' },
    ],
  },
  {
    id: '2',
    title: 'By student name',
    options: [
      { label: 'from A to Z', value: 'studentName:asc' },
      { label: 'from Z to A', value: 'studentName:desc' },
    ],
  },
];
